import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes

// @material-ui/core components
import { makeStyles } from "tss-react/mui";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Hidden from "@mui/material/Hidden";
import InputAdornment from "@mui/material/InputAdornment";
import { useSelector } from "react-redux";
import Input from "@mui/material/Input";
// @mui/icons-material
import Clear from "@mui/icons-material/Clear";
import Check from "@mui/icons-material/Check";

// core components

import styles from "assets/jss/xrs/components/customInputStyle.js";
import Context from "utils/context";

const useStyles = makeStyles()(() => styles);

export default function CustomInput(props) {
  const currency = useSelector((state) => state.GetSiteDetailsReducer.currency);

  const {
    formControlProps,
    id,
    helperText,
    label,
    labelProps,
    inputProps,
    error,
    white,
    showCurrency,

    success,
    multiline,
    reg,
  } = props;
  const { classes, cx } = useStyles();
  const labelClasses = cx({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error,
  });

  const underlineClasses = cx({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true,
    [classes.whiteUnderline]: white,
  });
  const rootClasses = cx(classes.fieldSet);

  const inputClasses = cx({
    [classes.input]: true,
    [classes.whiteInput]: white,
  });

  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = cx(formControlProps.className, classes.formControl);
  } else {
    formControlClasses = classes.formControl;
  }
  return (
    <FormControl {...formControlProps} className={formControlClasses}>
      {inputProps.placeholder !== undefined || label !== undefined ? (
        <InputLabel
          shrink={false}
          className={
            white === true
              ? classes.labelRootWhite
              : classes.labelRoot + " " + labelClasses
          }
          htmlFor={id}
          {...labelProps}
        >
          <Hidden mdUp>
            {label !== undefined ? label : inputProps.placeholder}
          </Hidden>
          <Hidden smDown>
            {inputProps.placeholder !== undefined
              ? inputProps.placeholder
              : label !== undefined
              ? label
              : null}
          </Hidden>
        </InputLabel>
      ) : null}
      <Input
        classes={{
          input: inputClasses,
          root: rootClasses,
          disabled: classes.disabled,
          underline: underlineClasses,
        }}
        id={id}
        multiline={multiline}
        rows={multiline ? 3 : 1}
        startAdornment={
          showCurrency ? (
            <InputAdornment
              classes={{ root: classes.currency }}
              position="start"
            >
              {currency}
            </InputAdornment>
          ) : (
            false
          )
        }
        mind="ters"
        variant="outlined"
        ref={reg}
        inputProps={{ ...inputProps }}
      />
      {helperText !== undefined ? (
        <Hidden mdUp>
          <FormHelperText
            className={classes.helperTextRoot}
            id="name-error-text"
          >
            {helperText}
          </FormHelperText>
        </Hidden>
      ) : null}
      {error ? (
        <Clear className={classes.feedback + " " + classes.labelRootError} />
      ) : success ? (
        <Check className={classes.feedback + " " + classes.labelRootSuccess} />
      ) : null}
    </FormControl>
  );
}

CustomInput.propTypes = {
  label: PropTypes.string,
  helperText: PropTypes.string,
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  showCurrency: PropTypes.bool,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  reg: PropTypes.object,
  multiline: PropTypes.bool,
};
